import React from 'react';

/**
 * The X (formerly Twitter) logo.
 *
 * Font Awesome only gained `fa-x-twitter` in 6.4.2 and this app loads 6.4.0, so that
 * class renders a zero-width nothing — the icon was silently missing from the footer.
 * Drawing it inline fixes it without moving every other icon to a new Font Awesome build.
 *
 * Sized in `em` and filled with `currentColor` so it inherits from its link exactly the
 * way the neighbouring `<i className="fa-brands …">` icons do.
 */
export const XIcon: React.FC = () => (
  <svg
    viewBox="0 0 512 512"
    role="img"
    aria-hidden="true"
    focusable="false"
    style={{ width: '1em', height: '1em', fill: 'currentColor', verticalAlign: '-0.125em' }}
  >
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
  </svg>
);

export default XIcon;
